module.exports = __webpack_public_path__ + "img/selectDownF38235.1ae81eef.svg";